import { BonusCustomerCondition, CustomerBonusSettlementSupplier } from '@synergy/models';
import { getConditionValue } from '@synergy/utils';

interface GetRecalculatedBonusParams {
    value: string | null;
    bonusConditionId: number;
    bonusConditions: BonusCustomerCondition[];
    customerBonusSettlement: CustomerBonusSettlementSupplier;
}

export const getCalculatedBonus = ({
    value,
    bonusConditionId,
    bonusConditions,
    customerBonusSettlement,
}: GetRecalculatedBonusParams): number => {
    const { bonusConditionValues } = customerBonusSettlement;

    if (!value && bonusConditionValues.every(condition => !condition.value || condition.value === 0)) {
        return 0;
    }

    let result = 0;

    bonusConditions.forEach(condition => {
        const conditionValue = getConditionValue(condition);

        if (condition.bonusCondition.id === bonusConditionId) {
            result += conditionValue * (value ? Number(value) : 0);
        } else {
            result +=
                conditionValue *
                (bonusConditionValues.find(c => c.bonusConditionId === condition.bonusCondition.id)?.value ?? 0);
        }
    });

    return result;
};
